// src/pages/Search.jsx
import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import heroImg from "../assets/homePageImage.jpg";   

function Search() {
  const navigate = useNavigate();
  
  // one piece of state just to collect the form values for now
  const [form, setForm] = useState({
    city: "",
    zip: "",
    beds: "",
    baths: "",
    sqft: "",
    stories: "",
    priceMin: "",
    priceMax: "",
    propertyType: "",
    yearBuilt: "",
    garage: "",
    basement: "",
  });

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    // Create URL parameters from form data
    const params = new URLSearchParams();
    Object.entries(form).forEach(([key, value]) => {
      if (value) {
        params.append(key, value);
      }
    });
    navigate(`/listings?${params.toString()}`);
  };

  return (
    <div className="search-page">
      {/* -------- hero section with search box overlay -------- */}
      <div
        className="search-hero"
        style={{ backgroundImage: `url(${heroImg})` }}
      >
        <div className="overlay">
          <h1 className="hero-title">Find Your California Home</h1>
          <p className="hero-sub">
            Explore the best properties in the Golden State
          </p>

          {/* -------- advanced-search box positioned over image -------- */}
      <div className="search-box">
        <h2>Advanced Search</h2>

        <form onSubmit={handleSubmit} className="search-grid">
          {/* row 1 */}
          <input
            name="city"
            placeholder="City"
            value={form.city}
            onChange={handleChange}
          />
          <input
            name="zip"
            placeholder="ZIP"
            value={form.zip}
            onChange={handleChange}
          />
          <input
            name="beds"
            placeholder="Beds"
            value={form.beds}
            onChange={handleChange}
          />
          <input
            name="baths"
            placeholder="Baths"
            value={form.baths}
            onChange={handleChange}
          />

          {/* row 2 */}
          <input
            name="sqft"
            placeholder="Sq Ft"
            value={form.sqft}
            onChange={handleChange}
          />
          <input
            name="stories"
            placeholder="Stories"
            value={form.stories}
            onChange={handleChange}
          />
          <input
            name="priceMin"
            placeholder="Price Min"
            value={form.priceMin}
            onChange={handleChange}
          />
          <input
            name="priceMax"
            placeholder="Price Max"
            value={form.priceMax}
            onChange={handleChange}
          />

          {/* row 3 */}
          <select
            name="propertyType"
            value={form.propertyType}
            onChange={handleChange}
          >
            <option value="">Property Type</option>
            <option>Single Family</option>
            <option>Townhouse</option>
            <option>Condo</option>
            <option>Multi-Family</option>
          </select>

          <input
            name="yearBuilt"
            placeholder="Year Built"
            value={form.yearBuilt}
            onChange={handleChange}
          />

          <select
            name="garage"
            value={form.garage}
            onChange={handleChange}
          >
            <option value="">Garage</option>
            <option value="1">Yes</option>
            <option value="0">No</option>
          </select>

          <select
            name="basement"
            value={form.basement}
            onChange={handleChange}
          >
            <option value="">Basement</option>
            <option value="1">Yes</option>
            <option value="0">No</option>
          </select>

          {/* row 4  (button spans full grid) */}
          <button type="submit" className="search-btn">
            Search
          </button>
        </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Search;
